function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "House Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "house-icon-s4csch1nga",
  d: "M20.49.216l18.757 14.068c.479.36.576 1.038.217 1.517-.36.479-1.038.575-1.517.217l-.648-.487.036 21.878c0 .6-.485 1.086-1.084 1.086H3.426c-.597 0-1.082-.484-1.083-1.082l-.035-21.828-.574.433c-.48.358-1.158.262-1.517-.217-.36-.479-.262-1.158.217-1.517L19.19.216c.386-.289.915-.289 1.3 0zm-.65 2.22L4.47 13.967c.002.032.004.063.004.095l.035 22.267H15.2v-10.64c0-.598.486-1.083 1.084-1.083h7.035c.598 0 1.084.485 1.084 1.083v10.64h10.763l-.035-22.263c0-.052.004-.102.01-.152l-15.3-11.476zm2.396 24.336h-4.869v9.555h4.868v-9.555z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-162 -484) translate(0 443) translate(1 46) translate(161) translate(6.5 .5)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#house-icon-s4csch1nga"
}));

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.dde3df63.svg";
export { ForwardRef as ReactComponent };